import {Controller} from '@hotwired/stimulus';

/**
 * JS de la page de subscription à une offre EMS
 * ex https://manager.e-monsite.com/site/subscription/subscribe/pro
 */
export default class extends Controller {
  static targets = [
    'otherPaymeans',
    'invoiceCoords',
    'form',
    'legalform',
    'legalnameRow',
    'country',
    'tvaIntraRow',
    'paymeanContainer',
    'userdomainFormContainer',
  ];
  static values = {
    checkCountryUrl: String,
  };

  connect() {
    this.formTarget.addEventListener('change', this.onFormchange.bind(this));
    this.formTarget.dispatchEvent(new Event('change'));
  }

  onFormchange(event) {
    const checkedPaymeanInput = this.formTarget.querySelector('input[name="command[paymean]"]:checked');
    this.invoiceCoordsTarget.classList.toggle('show', checkedPaymeanInput && checkedPaymeanInput.value !== 'stripe');
  }

  legalformTargetConnected(element) {
    element.addEventListener('change', (event) => {
      this.legalnameRowTarget.classList.toggle('d-none', event.target.value === 'individual');
      // trigger le change sur le country pour forcer l'update du champs "tva intra"
      this.countryTarget.dispatchEvent(new Event('change'));
    });
    element.dispatchEvent(new Event('change'));
  }

  countryTargetConnected(element) {
    element.addEventListener('change', (event) => {
      const legalform = this.legalformTarget.value;

      if (legalform !== 'corporation') {
        this.tvaIntraRowTarget.classList.add('d-none');
        return;
      }

      const formDatas = new FormData();
      formDatas.append('country', event.target.value);

      fetch(this.checkCountryUrlValue, {
        method: 'POST',
        body: formDatas,
      })
        .then((response) => response.json())
        .then((data) => {
          this.tvaIntraRowTarget.classList.toggle('d-none', !data.tva_intra_needed);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
    element.dispatchEvent(new Event('change'));
  }

  userdomainFormContainerTargetConnected(element) {
    // Si le form des domaine est affiché, on doit le remplir avant de passer au paiement
    this.paymeanContainerTarget.classList.add('d-none');

    // affiche ou non les champs "nom structure" et "no siren" du form. C'est dégueu là mais j'ai pas le time, à refacto
    this.element.querySelector('#userdomain_legalform').addEventListener('change', (event) => {
      const value = event.target.value;

      if (value === 'individual') {
        this.element.querySelector('#userdomain_organisation').closest('.form-row').classList.add('d-none');
        this.element.querySelector('#userdomain_legalnumber').closest('.form-row').classList.add('d-none');
      } else {
        this.element.querySelector('#userdomain_organisation').closest('.form-row').classList.remove('d-none');
        this.element.querySelector('#userdomain_legalnumber').closest('.form-row').classList.remove('d-none');
      }
    });
    this.element.querySelector('#userdomain_legalform').dispatchEvent(new Event('change'));
  }

  userdomainFormContainerTargetDisconnected(element) {
    this.paymeanContainerTarget.classList.remove('d-none');
  }
}
